<template>
  <section class="flex flex-col gap-4 h-[calc(95vh-120px)] overflow-y-auto py-2 px-4">
    <JobApplicationUserDetails
      :user-details="selectedApplication?.user_details"
      :resume-file-details="selectedApplication?.resume_file_details"
      :applicant-profile="applicantProfile"
    />

    <div class="flex flex-col md:flex-row gap-4 min-w-0">
      <!-- Job posting data section -->
      <div class="w-full md:w-1/2 min-w-0 border-[1px] rounded-lg border-gray-200 overflow-hidden shadow-sm">
        <div
          class="flex justify-between items-center border-b border-gray-200 p-4 bg-gray-50"
        >
          <div class="text-lg flex items-center">
            <Briefcase class="w-4 h-4 inline mr-1" />
            <router-link :to="`/jobs/${selectedApplication?.open_role_details?.id}`" class="text-lg hover:underline">Job position details</router-link>
          </div>
          <span class="text-sm text-gray-500">
            Posted
            {{
              selectedApplication?.open_role_details?.created_at
                ? formatDate(selectedApplication.open_role_details.created_at)
                : 'N/A'
            }}
          </span>
        </div>
        <div class="p-4">
          <JobMainData
            :role-data="selectedApplication?.open_role_details"
            minimal
          />
          <!-- Job Match Results -->
          <div v-if="selectedApplication?.match_status && (isOwner || isGuide)" class="mt-4 pt-4 border-t">
            <JobMatchResults 
              :application="selectedApplication"
              @update="$emit('application-updated', $event)"
            />
          </div>
        </div>
      </div>

      <!-- Application data section -->
      <div class="w-full md:w-1/2 min-w-0">
        <JobApplicationDataSection
          :application="selectedApplication"
          :application-id="applicationId"
          @preview-email="$emit('preview-email')"
          @send-email="$emit('send-email')"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import JobApplicationUserDetails from '@/components/common/jobApplication/JobApplicationUserDetails.vue'
import JobApplicationDataSection from '@/components/common/jobApplication/JobApplicationDataSection.vue'
import JobMainData from '@/components/common/JobMainData.vue'
import JobMatchResults from '@/components/common/jobApplication/JobMatchResults.vue'
import { formatDate } from '@/utils/formatDate'
import { Briefcase } from 'lucide-vue-next'
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { useAuth } from '@/composables/useAuth'

const props = defineProps<{
  selectedApplication: any
  applicantProfile: any
  applicationId: string | null
}>()

const userStore = useUserStore()
const { isGuide } = useAuth()

const isOwner = computed(() => {
  return props.selectedApplication?.user_details?.id === userStore.currentUser?.id
})

defineEmits<{
  'preview-email': []
  'send-email': []
  'application-updated': [application: any]
}>()
</script>